import * as routes from 'client/routes/manifest';
import { AppContent } from 'content/AppContent';

import { MetaContentValues } from '../MetaContentValues';

const submittingLimitedCompanyMortgageApplication: AppContent['submittingLimitedCompanyMortgageApplication'] =
  {
    pageTitle: 'Submitting a Limited Company mortgage application',
    metaContent: MetaContentValues.SubmittingLimitedCompanyMortgageApplication,
    backButtonLabel: 'Back',
    backButtonHref: routes.PlacingBusiness,
    infoPanel: {
      contentSections: [
        {
          sectionID: 'Submitting-a-LCM-section-1',
          sectionBody: [
            {
              text: 'To submit a Ltd company application, you will need to follow the below steps:',
            },
            {
              list: [
                'Log into BM Solutions Online using your normal log in details',
                'Select Create application',
                'Complete the broker details section',
                'Select yes to the “Is this a Ltd company application?”',
                'Confirm that you have permission of all directors and shareholders to allow credit checks',
                'Complete the remaining details on the page',
                'All applications will be Business Buy To Let',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-2',
          sectionBody: [
            {
              text: 'After selecting the “Next” button complete the following screen by:',
            },
            {
              list: [
                'Selecting the application type “Purchase” or “Remortgage”',
                'Indicate whether the company has an accountant',
                'Answer the next 4 questions about the company - depending upon the answer selected the application may not be able to proceed',
                'These questions can be amended up until “Next” has been selected',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-3',
          sectionBody: [
            {
              text: 'To select and validate the Ltd company follow the following steps',
            },
            {
              list: [
                'Input either the company name or company number',
                'A list of companies will appear for you to select the correct Ltd company',
                'At this point we will complete validation checks for the company against our policy',
                'If the company is outside our policy you will receive a message and the application will not be able to continue.',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-4',
          sectionBody: [
            {
              text: 'Example reasons for why the application will be stopped',
            },
            {
              list: [
                'Company SIC codes not within policy',
                'Company not active or open',
                'The property to be mortgaged, the Ltd company, directors, shareholders, or correspondence address is not located in England, Scotland, or Wales',
                'More than 4 directors/shareholders',
                'A shareholders or directors under the age of 21',
                'Debenture or floating charge exists',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-5',
          sectionBody: [
            {
              text: 'Once the validity checks have been completed and the application can proceed complete the following',
            },
            {
              list: [
                'If the registered company address differs from Royal Mail confirm that address format is correct',
                'Input a different address if the company has a different correspondence address than the registered address on Companies House',
                'Specify if the Ltd company requires documentation sent in an accessible format - e.g - braille, large print, etc',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-6',
          sectionBody: [
            {
              text: 'The next screens will have director and shareholder personal information pulled through from Companies House.',
            },
            {
              text: 'The following data is read only and cannot be amended',
            },
            {
              list: [
                'Role',
                'Appointed on/before',
                'First Name',
                'Surname',
                'DOB - Month and Year',
                'Middle name /Second middle name',
                'Country of Residence',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-7',
          sectionBody: [
            {
              text: 'The following data can be amended',
            },
            {
              list: [
                'Verification Method',
                'Landlord Experience',
                'Name History',
                'Contact Details (e.g., phone, email, etc.)',
                'Address History',
                'DOB - Day',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-8',
          sectionBody: [
            {
              text: 'You will need to complete any other information required. Once the full mortgage application is submitted, the following fields will become read-only',
            },
            {
              list: [
                'DOB - Day',
                'Director and/or shareholder current addresses',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-9',
          sectionBody: [
            {
              text: 'The “Decision in Principle” is subject to the following checks',
            },
            {
              list: [
                'Due diligence to ensure compliance with Know Your Business (KYB) regulatory requirements',
                'Satisfactory Commercial Bureau Assessment',
              ],
            },
          ],
        },
        {
          sectionID: 'Submitting-a-LCM-section-10',
          sectionBody: [
            {
              text: 'For some applications you will be asked for director and/or shareholder identification documents. These certified copies of the documents will need to be uploaded to the application.',
            },
            {
              text: 'When completing the full mortgage application for limited companies, even if the customers are not portfolio landlords, you will need to complete full details of existing properties. This will need to include properties the Ltd company has and any BTL properties directors and/or shareholders own individually, together, or with anyone else.',
            },
          ],
        },
      ],
    },
  };

export default submittingLimitedCompanyMortgageApplication;
